module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Extrabld.dd531b93b0197c7699494476e613d438.woff2";